import React, { Component } from 'react';
import { Container, Row, Col, FormGroup, Label, Card, CardBody, Button } from 'reactstrap';
import { Form, Field, reduxForm } from 'redux-form'; // ES6
import { ReduxInput } from '../ReduxInput';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import propTypes from 'prop-types';
import DashboardLogoGroup from '../DashboardLogoGroup/DashboardLogoGroup';
import { isRequired,isValidEmail } from '../../components/ReduxInput/Validators';

class Login extends Component {
  constructor(props) {
    super(props);
    this.continueAsGuest = this.continueAsGuest.bind(this);
  }

  continueAsGuest() {
    const { dispatchContinueAsGuest } = this.props;
    dispatchContinueAsGuest();
  }

  render() {
    let { handleSubmit, errorText } = this.props;
    return (
      <div>
        <Row>
          <DashboardLogoGroup />
        </Row>
        <div className="app flex-row animated fadeIn mt-5 pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col md="6">
                <Form onSubmit={handleSubmit}>
                  <Card >
                    <CardBody>
                      <FormGroup className="mb-4">
                        {errorText ?
                          <Alert id="errorAlert" className="animated shake" color="danger"> {errorText.message} </Alert>
                          :
                          null}
                      </FormGroup>
                      <h1>Sign in</h1>
                      <p className="text-muted">Sign in to your account below or 
                        {/*
                        <Link id="register" to="/register">
                          <span className="text-success"> Register </span>
                        </Link>
                        - or -
                        */}
                        <Link id="registerguest" to="/guest">
                          <span className="text-success"> Request Access </span>
                        </Link>
                        {/* or <Link to="/register" > continue as guest. </Link> */}
                      </p>

                      <FormGroup className="mb-4">
                        <Label htmlFor="email">Email </Label>
                        <Field
                          id="email"
                          name="email"
                          type="text"
                          placeholder="email address"
                          validate={[isRequired, isValidEmail]}
                          component={ReduxInput} />
                      </FormGroup>

                      <FormGroup className="mb-4">
                        <Label htmlFor="password">Password </Label>
                        <Field
                          id="password"
                          name="password"
                          type="password"
                          validate={[isRequired]}
                          placeholder="Password" component={ReduxInput} />
                      </FormGroup>
                      <Row>
                        <Col xs="6">
                          <Button id='loginButton' type="submit" color="primary" className="px-4">Login</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Link id="forgotPassword" to="/reset" >Forgot password?</Link>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  handleSubmit: propTypes.func,
  errorText: propTypes.any,
  dispatchContinueAsGuest: propTypes.func
};


export default reduxForm({
  form: "Login",   // a unique identifier for this form
  destroyOnUnmount: false,         // preserve form data
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
})(Login);





// WEBPACK FOOTER //
// ./src/components/Authentication/Login.js